/* Track order — hands off to Shopify's own order-status page, which is the
   source of truth. A second status screen here would eventually disagree
   with the first. */
(() => {
  'use strict';
  const $ = s => document.querySelector(s);
  const go = $('#track-go');
  if (!go) return;

  const out = $('#track-result');
  const email = $('#track-email');
  const num = $('#track-id');

  go.addEventListener('click', () => {
    const e = (email.value || '').trim();
    const n = (num.value || '').trim().replace(/^#/, '');
    if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(e)) {
      out.textContent = 'Enter the email address the order was placed with.';
      out.className = 'pin-result bad';
      email.focus();
      return;
    }
    if (!n) {
      out.textContent = 'Enter your order number.';
      out.className = 'pin-result bad';
      num.focus();
      return;
    }
    out.textContent = 'Opening your order…';
    out.className = 'pin-result ok';
    window.location.href = '/account/login?checkout_url=' +
      encodeURIComponent('/account/orders') + '&return_url=' + encodeURIComponent('/account');
  });
})();
